"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _apolloLinkError = require("apollo-link-error");

var _onNetworkError = _interopRequireDefault(require("./onNetworkError"));

var _handleTwoFactor = _interopRequireDefault(require("./handleTwoFactor"));

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var _default = function _default(options) {
  return (0, _apolloLinkError.onError)(function (_ref) {
    var graphQLErrors = _ref.graphQLErrors,
        networkError = _ref.networkError,
        response = _ref.response,
        operation = _ref.operation,
        forward = _ref.forward; // console.error('on error')

    if (graphQLErrors) {
      var _iterator = _createForOfIteratorHelper(graphQLErrors),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var graphQLError = _step.value;

          if (graphQLError.error === 'PermissionsError' && graphQLError.type === 'needsTwoFactorCode') {
            if (options.promptTwoFactorCode) {
              return (0, _handleTwoFactor["default"])({
                options: options,
                graphQLErrors: graphQLErrors,
                networkError: networkError,
                response: response,
                operation: operation,
                forward: forward
              });
            }
          }
        } // console.error(graphQLErrors)

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    if (networkError) {
      var result = (0, _onNetworkError["default"])({
        graphQLErrors: graphQLErrors,
        networkError: networkError,
        response: response,
        operation: operation,
        forward: forward
      });
      if (result) return result;
    }

    return options.onError({
      graphQLErrors: graphQLErrors,
      networkError: networkError,
      response: response,
      operation: operation,
      forward: forward
    });
  });
};

exports["default"] = _default;